import {injectable} from "inversify";

declare const fbq;

@injectable()
export class AnalyticsStore {

    trackRegistrationCompleted() {
        this.trackFbq('CompleteRegistration');
    }

    trackSubscribed() {
        this.trackFbq('Subscribe');
    }

    trackFbq(event, payload = {}) {
        if (typeof fbq !== 'undefined') {
            fbq('track', event, payload);
        }
    }

}
